// @ts-check

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Materials from './Materials';
import EnergyEfficiency from './EnergyEfficiency';
import NetZeroCarbon from './NetZeroCarbon';
import useFormStyles from '../../common/FormStyle';
import Typography from '@material-ui/core/Typography';
import { GoToPlootoButton } from '../common/GoToPlootoButton'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh"
  }
}))

function FormSustainability(props) {
  const styles = useStyles();
  const formStyles = useFormStyles();

  return (
    <Box paddingX={2} paddingY={2} className={styles.root}
      display="flex" flexDirection="column">
      <Typography variant="h5" className={formStyles.bold}>Sustainability</Typography>
      <Box paddingY={2}>
        <Materials />
        <EnergyEfficiency />
        <NetZeroCarbon />
      </Box>
      <GoToPlootoButton />
    </Box>
  )
}

export default FormSustainability